var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex flex_gap_5" }, [
    _c("div", [
      _vm.drug.cool
        ? _c("i", { staticClass: "icon icon-snowflake" })
        : _vm._e(),
    ]),
    _vm._v(" "),
    _vm.getDiscountPrices()
      ? _c("div", { staticClass: "pointer" }, [
          _c("button", { staticClass: "btn btn-outline-info btn-xs" }, [
            _c("i", {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: {
                    show: _vm.toolOpen,
                    placement: "bottom-center",
                    content: _vm.getDiscountPrices(true),
                    classes: "discount_tooltip tooltip_on_modal",
                  },
                  expression:
                    "{\n                    show: toolOpen,\n                    placement: 'bottom-center',\n                    content: getDiscountPrices(true),\n                    classes: 'discount_tooltip tooltip_on_modal'\n                  }",
                },
              ],
              staticClass: "icon-fa icon-fa-percent",
            }),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      [
        _c(
          "v-popover",
          { attrs: { "auto-hide": true, popoverClass: "tooltip_on_modal" } },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-outline-info btn-xs",
                on: {
                  click: function ($event) {
                    return _vm.getDrugInfo()
                  },
                },
              },
              [_c("i", { staticClass: "icon-fa icon-fa-info" })]
            ),
            _vm._v(" "),
            _c(
              "template",
              { slot: "popover" },
              [
                !_vm.drugInfoLoading
                  ? [
                      _vm.projectInfo[_vm.drug.id] &&
                      _vm.projectInfo[_vm.drug.id][_vm.$editNewOrder.site_id]
                        ? _c(
                            "div",
                            [
                              _c("div", {
                                staticClass: "mb-1",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.printDrugInfo(
                                      _vm.projectInfo[_vm.drug.id][
                                        _vm.$editNewOrder.site_id
                                      ]
                                    )
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _vm.projectInfo[_vm.drug.id][
                                _vm.$editNewOrder.site_id
                              ].mirror_sources
                                ? _vm._l(
                                    _vm.projectInfo[_vm.drug.id][
                                      _vm.$editNewOrder.site_id
                                    ].mirror_sources,
                                    function (source) {
                                      return _c(
                                        "div",
                                        {
                                          staticClass:
                                            "mirror_source_data flex",
                                        },
                                        [
                                          source.data.image
                                            ? _c(
                                                "div",
                                                { staticClass: "w-50 mr-1" },
                                                [
                                                  _c("img", {
                                                    attrs: {
                                                      src: source.data.image,
                                                      alt: "",
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", [
                                            _c("p", [
                                              _vm._v("Данные на проекте: "),
                                              _c("strong", [
                                                _vm._v(_vm._s(source.title)),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v("препарат: "),
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: `${
                                                      source.data.link_share ??
                                                      source.data.link
                                                    }`,
                                                    target: "_blank",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(source.data.title)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            source.data.manufacturer
                                              ? _c("p", [
                                                  _vm._v(
                                                    "производитель:\n                    "
                                                  ),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        source.data.manufacturer
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            source.data.country
                                              ? _c("p", [
                                                  _vm._v("страна: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        source.data.country
                                                      )
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            source.data.block_reason
                                              ? _c("p", [
                                                  _c("strong", [
                                                    _vm._v(
                                                      "препарат НЕ отображается\n                    (" +
                                                        _vm._s(
                                                          source.data
                                                            .block_reason
                                                        ) +
                                                        ")"
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            source.data.price
                                              ? _c("p", [
                                                  _vm._v("цена: "),
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(source.data.price)
                                                    ),
                                                  ]),
                                                ])
                                              : _vm._e(),
                                          ]),
                                        ]
                                      )
                                    }
                                  )
                                : _vm._e(),
                            ],
                            2
                          )
                        : _c("div", [
                            _vm._v("\n            Нет данных\n          "),
                          ]),
                    ]
                  : [_vm._v("\n          Загрузка ....\n        ")],
                _vm._v(" "),
                _c(
                  "button",
                  {
                    directives: [
                      { name: "close-popover", rawName: "v-close-popover" },
                    ],
                    staticClass: "btn btn-theme btn-sm",
                  },
                  [_vm._v("\n          Закрыть\n        ")]
                ),
              ],
              2
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }